<template>
  <div class="app-title">
    <span> {{ title }}</span>
  </div>
</template>

<script>
export default {
  computed: {
    title: {
      get: function () {
        return this.$store.state.app.title
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  text-align: center;
  color: white;
  font-size: 1.3em;
  margin: 10px;
}
</style>
